import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import styled, { css } from 'styled-components';

interface TitleFormProps {
	title?: string;
	subtitle?: string;
}

const Title = styled.h2`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.md }}
	`}
`;

const SubTitle = styled.p`
	${({ theme }) => css`
		${{ ...theme.fonts.body.md }}
	`}
`;

export function TitleForm({ title = '', subtitle = '' }: Readonly<TitleFormProps>): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Title>{I18n.get(title)}</Title>
			</Col>
			<Col>
				<SubTitle>{I18n.get(subtitle)}</SubTitle>
			</Col>
		</Row>
	);
}
